import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { getRaceFormDataFromApi } from './api'

export const useRaceFormData = ({
  meetingId,
  meetingDate,
  raceNumber,
}: {
  meetingId: string
  meetingDate: Date
  raceNumber: number
}) =>
  useQuery({
    queryKey: [queryKeys.racePageForm(meetingId, meetingDate, raceNumber)],
    queryFn: () => getRaceFormDataFromApi(meetingId, meetingDate, raceNumber),
    staleTime: Infinity,
  })
